import React, { useEffect, useState } from "react";
import './style.css';
import { Dropdown, Menu, Breadcrumb, Table, Spin, Button, Space, Input, Row, Col, Popconfirm, Tabs } from 'antd';
import { SyncOutlined, SearchOutlined, MoreOutlined, CopyOutlined, EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { getCompleteTemplate, getDraftTemplate, AdminAllProcessSelector, clearState, copyCompletedProcess, delCompletedProcess, SearchCompleteProcess, SearchDraftProcess } from './AdminAllProcessSlice';
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { useHistory, Link } from "react-router-dom";
import Container from '../Layout/Container';
import moment from 'moment';
import ability from '../../config/ability';
const { Search } = Input;
const { TabPane } = Tabs;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const ntop = "none";
const nbottom = "bottomCenter";


export default function AllProcess() {

  const dispatch = useDispatch();
  let history = useHistory()

  const [isLoading, setLoading] = React.useState(false);
  const [completeTepmalteData, setcompleteTepmalteData] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const [draftTepmalteData, setdraftTepmalteData] = useState([]);
  const [draftpage, setdraftPage] = useState(1);
  const [draftsearch, setdraftSearch] = useState('');

  const { isFetching, isCompSuccess, isDraftSuccess, isError, errorMessage, completeTepmalte, draftTepmalte } = useSelector(
    AdminAllProcessSelector
  );

  const defaultTab = localStorage.getItem('defaultTab') ? localStorage.getItem('defaultTab') : '1';


  const renderContent = (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    return obj;
  };

  const columns = [
    {
      title: 'Seen Stamp Name',
      dataIndex: 'compprocessname',
      render: (text, row, index) => {
        return {
          children: <a onClick={(e) => ViewCompleteTemplate(e, row)} style={{ marginBottom: 0 }}>{text}</a>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
    {
      title: 'No of Stages',
      dataIndex: 'compnostages',
      render: renderContent,
    },
    {
      title: 'Created On',
      dataIndex: 'compcreated_on',
      render: renderContent,
    },
    {
      title: 'Created By',
      dataIndex: 'compcreated_by',
      render: renderContent,
    },
    {
      title: 'Last Updated on',
      dataIndex: 'complast_updated_on',
      render: renderContent,
    },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      render: (text, row, index) => (
        <Dropdown
          overlay={() => completedmenu(row)}
          trigger={["click"]}
          placement="bottomRight"
          arrow
        >
          <a
            style={{ color: "#c5c7cd", fontSize: 25 }}
            onClick={(e) => e.preventDefault()}
          >
            <MoreOutlined />
          </a>
        </Dropdown>
      ),
    },
  ];

  const ViewCompleteTemplate = (e, row) => {
    e.preventDefault();
    history.push({
      pathname: '/view-seen-stamp',
      state: { tempId: row.key }
    });
  }

  const completedmenu = (row) => (
    <Menu onClick={(e) => CompletedMenuClick(e, row)}>
      <Menu.Item key="1">
        <Popconfirm
          title="Are you sure you want to duplicate this seen stamp?"
          onConfirm={(e) => CopyCompletedprocess(e, row)}
          okText="Yes"
          cancelText="No"
        >
          <CopyOutlined /> &nbsp; Duplicate
        </Popconfirm>
      </Menu.Item>
      <Menu.Item key="2">
        <EditOutlined /> &nbsp; Edit
      </Menu.Item>
      <Menu.Item key="3">
        <Popconfirm
          title="Are you sure you want to delete this seen stamp?"
          onConfirm={(e) => DelCompletedconfirm(e, row)}
          // onCancel={cancel}
          okText="Yes"
          cancelText="No"
          icon={<DeleteOutlined style={{ color: 'red' }} />}
        >
          <DeleteOutlined /> &nbsp; Delete
        </Popconfirm>
      </Menu.Item>
    </Menu>
  );


  const ChangeCompleteProcess = (v) => {

    if (search) {
      let q = search + '&limit=10&page=' + v.current;
      dispatch(SearchCompleteProcess(q)).then(res => {
        if (res) {
          let udata = res.data;
          setcompleteTepmalteData(udata);
          //setPage(1);
        }
      });
    }
    else {
      let q = v.current;
      setPage(v.current);
      dispatch(getCompleteTemplate(q));
    }
  }

  function callback(key) {
    // console.log(key);
    localStorage.setItem('defaultTab', key);
  }

  const CopyCompletedprocess = (e, row) => {
    e.preventDefault();
    dispatch(copyCompletedProcess(row.key));
    setTimeout(() => {
      dispatch(getCompleteTemplate(page));
    }, 100);

  }

  const CompletedMenuClick = (e, row) => {
    if (e.key == 2) {
      history.push({
        pathname: '/edit-seen-stamp',
        state: { templateId: row.key }
      });
    }
  }


  const DelCompletedconfirm = (e, row) => {
    e.preventDefault();
    // console.log(e.key + " " + row.key);
    dispatch(delCompletedProcess(row.key));
    setTimeout(() => {
      dispatch(getCompleteTemplate(page));
    }, 100);

  }



  const columnsDraft = [
    {
      title: 'Seen Stamp Name',
      dataIndex: 'draftname',
      render: (text, row, index) => {
        return {
          children: <a onClick={(e) => ViewCompleteTemplate(e, row)} style={{ marginBottom: 0 }}>{text}</a>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
    {
      title: 'Created On',
      dataIndex: 'draftcreated_on',
      render: renderContent,
    },
    {
      title: 'Created By',
      dataIndex: 'draftcreated_by',
      render: renderContent,
    },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      render: (text, row, index) => (
        <Dropdown
          overlay={() => draftmenu(row)}
          trigger={["click"]}
          placement="bottomRight"
          arrow
        >
          <a
            style={{ color: "#c5c7cd", fontSize: 25 }}
            onClick={(e) => e.preventDefault()}
          >
            <MoreOutlined />
          </a>
        </Dropdown>
      ),
    },
  ];

  const draftmenu = (row) => (
    <Menu onClick={(e) => DraftMenuClick(e, row)}>
      <Menu.Item key="1">
        <EditOutlined /> &nbsp; Edit
      </Menu.Item>
      <Menu.Item key="2">
        <Popconfirm
          title="Are you sure you want to delete this seen stamp?"
          onConfirm={(e) => DelDraftconfirm(e, row)}
          // onCancel={cancel}
          okText="Yes"
          cancelText="No"
          icon={<DeleteOutlined style={{ color: 'red' }} />}
        >
          <DeleteOutlined /> &nbsp; Delete
        </Popconfirm>
      </Menu.Item>
    </Menu>
  );



  const DraftMenuClick = (e, row) => {
    if (e.key == 1) {
      history.push({
        pathname: '/edit-seen-stamp-draft',
        state: { templateId: row.key }
      });
      //   history.push({
      //     pathname: '/edit-all-process',
      //     state: { allProcessName: row.processname}
      // });
    }
  }


  const DelDraftconfirm = (e, row) => {
    e.preventDefault();
    // console.log(e.key + " " + row.key);
    dispatch(delCompletedProcess(row.key));
    setTimeout(() => {
      dispatch(getDraftTemplate(draftpage));
    }, 100);
  }


  const ChangeDraftProcess = (v) => {

    if (draftsearch) {
      let q = draftsearch + '&limit=10&page=' + v.current;
      dispatch(SearchDraftProcess(q)).then(res => {
        if (res) {
          let udata = res.data;
          setdraftTepmalteData(udata);
        }
      });
    }
    else {
      let q = v.current;
      setdraftPage(v.current);
      dispatch(getDraftTemplate(q));
    }
  }



  useEffect(() => {
    setLoading(true);
    dispatch(clearState());
    dispatch(getCompleteTemplate(page));
    dispatch(getDraftTemplate(draftpage));
  }, []);

  useEffect(() => {

    if (isError) {
      setLoading(false);
      toast.error(errorMessage);

    }
    if (isCompSuccess) {
      setLoading(false);
      setcompleteTepmalteData(completeTepmalte);
    }

    if (isDraftSuccess) {
      setLoading(false);
      setdraftTepmalteData(draftTepmalte);
    }


  }, [isError, isCompSuccess, isDraftSuccess, setLoading, completeTepmalte, setcompleteTepmalteData, draftTepmalte, setdraftTepmalteData]);


  let completeddataSource = isLoading
    ? []
    : completeTepmalteData && completeTepmalteData.templates ? completeTepmalteData.templates.map(row => ({
      key: row.uuid,
      compprocessname: row.processName,
      compnostages: row.noOfStages,
      compcreated_on: moment(row.created_at).format("lll"),
      compcreated_by: row.createdBy,
      complast_updated_on: moment(row.updated_at).format("lll"),
      subject: row.processSubject
    })) : [];

  completeddataSource = completeddataSource ? completeddataSource.slice().sort((a, b) => a.compprocessname.toLowerCase().localeCompare(b.compprocessname.toLowerCase())) : [];

  let draftdataSource = isLoading
    ? []
    : draftTepmalteData && draftTepmalteData.drafts ? draftTepmalteData.drafts.map(row => ({
      key: row.uuid,
      draftname: row.processName,
      draftcreated_on: moment(row.created_at).format("lll"),
      draftcreated_by: row.createdBy,
      subject: row.processSubject
    })) : [];

  // draftdataSource = draftdataSource?draftdataSource.slice().sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())):[];




  return (
    <>
      <Container>

        <div className="site-layout-content" style={{ marginTop: 0, paddingTop: 0 }}>

          <div style={{ padding: 24, paddingTop: 16, position: 'relative' }}>

            <Space style={{ position: 'absolute', right: '15px', top: '30px', zIndex: '1' }}>
              {ability.can('allProcessTab', 'manage/editTemplates') &&
                <Link to="/manage-seen-stamp"><Button size="large" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 600, fontSize: 14 }} type="primary" ghost>Manage Seen Stamp</Button></Link>
              }
              {/* <Link to="/manage-seen-stamp"><Button size="large" style={{borderRadius:5,padding:'6.4px 8px',fontWeight:600,fontSize:14}}  type="primary" ghost>Manage Template</Button></Link> */}
              {ability.can('allProcessTab', 'createTemplates') &&
                <Link to="/new-seen-stamp"><Button size="large" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 600, fontSize: 14 }} type="primary" icon={<PlusOutlined />}>New Seen Stamp</Button></Link>
              }
            </Space>

            <Tabs defaultActiveKey={defaultTab} tabBarStyle={{ backgroundColor: "#ffffff", borderTop: '1px solid #dfe0eb', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', padding: 16, margin: 0 }} onChange={callback}>
              <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isFetching} />
              <TabPane tab={<p className="tabclass">Completed Seen Stamp ({completeTepmalteData && completeTepmalteData.count ? completeTepmalteData.count : 0})</p>} key="1" style={{ borderTop: 'none', color: '#000' }}>

                <Space style={{ backgroundColor: "#ffffff", padding: 16, width: '100%', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb' }} size="large">
                  <Row style={{ width: '100%' }}>
                    <Col span="10">
                      <Input placeholder="Search seen stamp" size="large" suffix={<SearchOutlined />}
                        onChange={e => {
                          const currValue = e.target.value;
                          setSearch(currValue);
                          let q = currValue + '&limit=10&page=1';
                          // console.log(q)
                          if (currValue) {
                            dispatch(SearchCompleteProcess(q)).then(res => {
                              if (res) {
                                let udata = res.data;
                                setcompleteTepmalteData(udata);
                                //setPage(1);
                              }
                            });
                          }
                          else {
                            dispatch(SearchCompleteProcess(q)).then(res => {
                              if (res) {
                                let udata = res.data;
                                setcompleteTepmalteData(udata);
                                setPage(1);
                              }
                            });
                          }

                        }} />
                    </Col>
                    <Col span="14" style={{ textAlign: 'right' }}>

                    </Col>
                  </Row>
                </Space>

                <Table
                  onChange={ChangeCompleteProcess}
                  columns={columns}
                  pagination={{ position: [ntop, nbottom], size: 'small', defaultPageSize: 10, total: completeTepmalteData.count, hideOnSinglePage: true }}
                  expandable={{
                    expandedRowRender: record => <div style={{ paddingLeft: 50 }}><p style={{ color: '#848484', marginBottom: 5 }}>Subject</p><p style={{ margin: 0, fontWeight: 'normal', color: '#40414c' }}>{record.subject}</p></div>,
                    rowExpandable: record => record.name !== 'Not Expandable',
                  }}
                  dataSource={completeddataSource} bordered />

              </TabPane>
              <TabPane tab={<p className="tabclass">Draft Seen Stamp ({draftTepmalteData && draftTepmalteData.count ? draftTepmalteData.count : 0})</p>} key="2">
                <Space style={{ backgroundColor: "#ffffff", padding: 16, width: '100%', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb' }} size="large">
                  <Row style={{ width: '100%' }}>
                    <Col span="10">
                      {/* <Search placeholder="Search process"  size="large"  /> */}
                      <Input placeholder="Search Seen Stamp" size="large" suffix={<SearchOutlined />}
                        onChange={e => {
                          const currValue = e.target.value;
                          setdraftSearch(currValue);
                          let q = currValue + '&limit=10&page=1';
                          // console.log(q)
                          if (currValue) {
                            dispatch(SearchDraftProcess(q)).then(res => {
                              if (res) {
                                let udata = res.data;
                                setdraftTepmalteData(udata);
                                //setdraftPage(1);
                              }
                            });
                          }
                          else {
                            dispatch(SearchDraftProcess(q)).then(res => {
                              if (res) {
                                let udata = res.data;
                                setdraftTepmalteData(udata);
                                setdraftPage(1);
                              }
                            });
                          }

                        }} />
                    </Col>
                    <Col span="14" style={{ textAlign: 'right' }}>

                    </Col>
                  </Row>
                </Space>

                <Table
                  onChange={ChangeDraftProcess}
                  columns={columnsDraft}
                  pagination={{ position: [ntop, nbottom], size: 'small', defaultPageSize: 10, total: draftTepmalteData.count, hideOnSinglePage: true }}
                  expandable={{
                    expandedRowRender: record => <div style={{ paddingLeft: 50 }}><p style={{ color: '#848484', marginBottom: 5 }}>Subject</p><p style={{ margin: 0, fontWeight: 'normal', color: '#40414c' }}>{record.subject}</p></div>,
                    rowExpandable: record => record.name !== 'Not Expandable',
                  }}
                  dataSource={draftdataSource} bordered />
              </TabPane>
            </Tabs>


          </div>

        </div>
      </Container>
    </>
  );
}
